import { useEffect, useRef, useState } from "react";

/**
 * Passe `shown` à true la première fois que l'élément entre dans la fenêtre,
 * puis cesse d'observer. Sans IntersectionObserver (vieux navigateur, tests),
 * le contenu est considéré comme visible d'emblée : rien ne reste caché.
 */
export function useInViewOnce<T extends Element>({
  rootMargin = "0px 0px -12% 0px",
  threshold = 0.12,
}: { rootMargin?: string; threshold?: number } = {}) {
  const ref = useRef<T | null>(null);
  const [shown, setShown] = useState(
    () => typeof IntersectionObserver === "undefined",
  );

  useEffect(() => {
    const el = ref.current;
    if (shown || !el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setShown(true);
          observer.disconnect();
        }
      },
      { rootMargin, threshold },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [shown, rootMargin, threshold]);

  return { ref, shown };
}
